<template>
  <NavigationMobile v-if="$store.getters.isMobile" />
  <Navigation v-else />
</template>

<script>
import Navigation from "./Navigation";
import NavigationMobile from "./NavigationMobile";
export default {
  name: "NavigationContainer",
  components: {
    Navigation,
    NavigationMobile
  }
};
</script>

<style></style>
